import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";

import CustomNavbar from "../../components/CustomNavbar";
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";

import messages from "../../redux/messages";
import SidebarConfig from "../../components/SidebarConfig";
import {
  deleteJobpositionRelated,
  editJobpositionRelated,
  getJobpositionRelated,
  saveJobpositionRelated,
} from "../../redux/jobpositionRelated/actions";
import { Typeahead } from "react-bootstrap-typeahead";
import { getOrgs } from "../../redux/organization/actions";
import { getJobPositions } from "../../redux/jobposition/actions";
import { getDivision } from "../../redux/division/actions";
import { getPersonalDivision } from "../../redux/divisionPersonal/actions";
import { getCenterCostWithPagination } from "../../redux/centercost/actions";
import { get_tasks } from "../../redux/tasks/actions";

const returnData = (value, type) => {
  var _list = [];
  switch (type) {
    case 1:
      value.map((item) => {
        _list = [..._list, { id: item.id, label: item.nombre }];
      });
      return _list;
    case 2:
      value.map((item) => {
        _list = [
          ..._list,
          {
            id: item.id,
            label: `${item.codigo ? item.codigo : ""} / ${
              item.descripcion ? item.descripcion : ""
            }`,
          },
        ];
      });
      return _list;
    case 3:
      value.map((item) => {
        _list = [
          ..._list,
          {
            id: item.id,
            label: `${item.descripcion ? item.descripcion : ""}`,
          },
        ];
      });
      return _list;
    default:
      break;
  }
};

const EvaluationType = (props) => {
  // const filters = [
  //   { id: "nombre_puesto", desc: "Puesto" },
  //   { id: "nombre_empresa", desc: "Empresa" },
  //   { id: "nombre_division", desc: "División" },
  //   { id: "division_personal", desc: "División Personal" },
  //   { id: "centro_costo", desc: "Centro de Costo" },
  // ];

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);
  const [empSelected, setEmpSelected] = useState([]);
  const [jobPositionSelected, setJobPositionSelected] = useState([]);
  const [positionSelected, setPositionSelected] = useState([]);
  const [divSelected, setDivSelected] = useState([]);
  const [divPersonalSelected, setDivPersonalSelected] = useState([]);
  const [centerCostlSelected, setCenterCostlSelected] = useState([]);
  const [_puesto, setPuesto] = useState("");
  const [_posicion, setPosicion] = useState("");
  const [_empresa, setEmpresa] = useState("");
  const [_division, setDivision] = useState("");
  const [_divisionPersonal, setDivisionPersonal] = useState("");
  const [_centroCosto, setCentroCosto] = useState("");
  // const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);

  const dispatch = useDispatch();

  const schema = Yup.object().shape({
    puesto: Yup.string().required("**Campo requerido"),
    posicion: Yup.string().required("**Campo requerido"),
    empresa: Yup.string().required("**Campo requerido"),
    division: Yup.string().required("**Campo requerido"),
    division_personal: Yup.string().required("**Campo requerido"),
    centro_costo: Yup.string().required("**Campo requerido"),
  });

  const schemaSearch = Yup.object().shape({
    puesto: Yup.string().notRequired(""),
    posicion: Yup.string().notRequired(""),
    empresa: Yup.string().notRequired(""),
    division: Yup.string().notRequired(""),
    division_personal: Yup.string().notRequired(""),
    centro_costo: Yup.string().notRequired(""),
  });

  const {
    loading,
    saveLoading,
    jobpositionRelated,
    jobpositionRelatedError,
    formError,
  } = useSelector((store) => store.jobpositionRelated);
  const pages = Math.ceil(
    jobpositionRelated ? jobpositionRelated.count / limit : 0
  );

  const { orgs, loading: loadingOrgs } = useSelector((store) => store.orgs);

  const {
    jobPositions,
    jobPositionsLength,
    loading: loadingJobPosition,
  } = useSelector((store) => store.jobPositions);

  const {
    tasks,
    tasksLength,
    loader: taskLoader,
  } = useSelector((store) => store.tasks);

  const {
    division,
    divisionLength,
    loading: loadingDivision,
  } = useSelector((store) => store.division);

  const {
    divisionPersonal,
    divisionPersonalLength,
    loading: loadingDivisionPersonal,
  } = useSelector((store) => store.divisionPersonal);

  const {
    centerCost,
    centerCostLength,
    loading: loadingCenterCost,
  } = useSelector((store) => store.centerCost);

  const columns = [
    {
      Header: "Código Puesto",
      accessor: "codigo",
      Filter: "",
      Cell: (value) => (
        <div style={{ minWidth: "130px" }}>
          {value.row.original.puesto
            ? value.row.original.list_puesto[0].codigo
            : "No ingresado"}
        </div>
      ),
    },
    {
      Header: "Puesto",
      accessor: "puesto",
      Filter: "",
      Cell: (value) => (
        <div style={{ minWidth: "130px" }}>
          {value.row.original.puesto
            ? value.row.original.list_puesto[0].descripcion
            : "No ingresado"}
        </div>
      ),
    },
    {
      Header: "Código Posición",
      accessor: "list_posicion[0].codigo",
      Filter: "",
      Cell: (value) => (
        <div style={{ minWidth: "130px" }}>
          {value.row.original.posicion
            ? value.row.original.list_posicion[0].codigo
            : "No ingresado"}
        </div>
      ),
    },
    {
      Header: "Posición",
      accessor: "posicion",
      Filter: "",
      Cell: (value) => (
        <div style={{ minWidth: "130px" }}>
          {value.row.original.posicion
            ? value.row.original.list_posicion[0].descripcion
            : "No ingresado"}
        </div>
      ),
    },
    {
      Header: "Empresa",
      accessor: "empresa",
      Filter: "",
      Cell: (value) => (
        <div style={{ minWidth: "130px" }}>
          {value.row.original.empresa
            ? value.row.original.list_empresa[0].nombre
            : "No ingresado"}
        </div>
      ),
    },
    {
      Header: "División",
      accessor: "division",
      Filter: "",
      Cell: (value) => (
        <div style={{ minWidth: "130px" }}>
          {value.row.original.division
            ? value.row.original.list_division[0].descripcion
            : "No ingresado"}
        </div>
      ),
    },
    {
      Header: "División personal",
      accessor: "division_personal",
      Filter: "",
      Cell: (value) => (
        <div style={{ minWidth: "140px" }}>
          {value.row.original.division_personal
            ? value.row.original.list_division_personal[0].descripcion
            : "No ingresado"}
        </div>
      ),
    },
    {
      Header: "Centro de costo",
      accessor: "centro_costo",
      Filter: "",
      Cell: (value) => (
        <div style={{ minWidth: "130px" }}>
          {value.row.original.centro_costo
            ? value.row.original.list_centro_costo[0].descripcion
            : "No ingresado"}
        </div>
      ),
    },
    {
      Header: "Fecha creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div style={{ minWidth: "130px" }}>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Editar registro</Tooltip>}
          >
            <Button
              size="sm"
              variant="link"
              type="button"
              onClick={() => onEdit(value.row.original, value.row.index)}
            >
              <i className="material-icons">edit</i>
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Eliminar registro</Tooltip>}
          >
            <Button
              size="sm"
              className="text-danger"
              variant="link"
              type="button"
              onClick={() => onDelete(value.row.original.id, value.row.index)}
            >
              <i className="material-icons">close</i>
            </Button>
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  // Métodos
  // const _getJobpositionRelated = (offs = offset, lim = limit, filt = filter) =>
  const _getJobpositionRelated = (
    offs = offset,
    lim = limit,
    puest = _puesto,
    pos = _posicion,
    emp = _empresa,
    div = _division,
    divPers = _divisionPersonal,
    centr = _centroCosto
  ) =>
    dispatch(
      getJobpositionRelated({
        offset: offs,
        limit: lim,
        // tipo_busqueda: tipoBusqueda.id,
        // filter: filt,
        // puesto: puest,
        // empresa: emp,
        // division: div,
        // division_personal: divPers,
        // centro_costo: centr,
        tipoBusqueda: "multiple",
        filter: JSON.stringify({
          puesto: puest !== "" ? puest : undefined,
          posicion: pos !== "" ? pos : undefined,
          empresa: emp !== "" ? emp : undefined,
          division: div !== "" ? div : undefined,
          division_personal: divPers !== "" ? divPers : undefined,
          centro_costo: centr !== "" ? centr : undefined,
        }),
      })
    );

  useEffect(() => {
    dispatch(get_tasks({}, 2));
    _getJobpositionRelated();
    dispatch(getOrgs(2));
    dispatch(getJobPositions({}, 2));
    dispatch(getDivision({}, 2));
    dispatch(getPersonalDivision({}, 2));
    dispatch(getCenterCostWithPagination({}));
  }, []);

  const onAdd = () => {
    setJobPositionSelected([]);
    setPositionSelected([]);
    setEmpSelected([]);
    setDivSelected([]);
    setDivPersonalSelected([]);
    setCenterCostlSelected([]);
    setOpenSearch(false);
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    if (item.puesto) {
      setJobPositionSelected([
        {
          id: item.puesto,
          label: `${
            item.list_puesto[0].codigo ? item.list_puesto[0].codigo : ""
          } / ${
            item.list_puesto[0].descripcion
              ? item.list_puesto[0].descripcion
              : ""
          }`,
        },
      ]);
    } else {
      setJobPositionSelected([]);
    }
    if (item.posicion) {
      setPositionSelected([
        {
          id: item.posicion,
          label: `${
            item.list_posicion[0].codigo ? item.list_posicion[0].codigo : ""
          } / ${
            item.list_posicion[0].descripcion
              ? item.list_posicion[0].descripcion
              : ""
          }`,
        },
      ]);
    } else {
      setPositionSelected([]);
    }
    if (item.empresa) {
      setEmpSelected([
        {
          id: item.empresa,
          label: `${
            item.list_empresa[0].nombre ? item.list_empresa[0].nombre : ""
          }`,
        },
      ]);
    } else {
      setEmpSelected([]);
    }
    if (item.division) {
      setDivSelected([
        {
          id: item.division,
          label: `${
            item.list_division[0].descripcion
              ? item.list_division[0].descripcion
              : ""
          }`,
        },
      ]);
    } else {
      setDivSelected([]);
    }
    if (item.division_personal) {
      setDivPersonalSelected([
        {
          id: item.division_personal,
          label: `${
            item.list_division_personal[0].descripcion
              ? item.list_division_personal[0].descripcion
              : ""
          }`,
        },
      ]);
    } else {
      setDivPersonalSelected([]);
    }
    if (item.centro_costo) {
      setCenterCostlSelected([
        {
          id: item.centro_costo,
          label: `${
            item.list_centro_costo[0].descripcion
              ? item.list_centro_costo[0].descripcion
              : ""
          }`,
        },
      ]);
    } else {
      setCenterCostlSelected([]);
    }
    setOpenSearch(false);
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onOpenSearch = () => {
    setJobPositionSelected([]);
    setPositionSelected([]);
    setEmpSelected([]);
    setDivSelected([]);
    setDivPersonalSelected([]);
    setCenterCostlSelected([]);
    setOpenSearch(true);
    setShowModal(true);
  };

  // const onSearch = (e) => {
  //   e.preventDefault();
  //   setFilter(e.target.filter.value);
  //   const oOffset = 0;
  //   setOffset(oOffset);
  //   setCurrentPage(1);
  //   _getJobpositionRelated(oOffset, limit, e.target.filter.value);
  // };

  const onSubmit = async (req) => {
    if (!edit) {
      dispatch(saveJobpositionRelated(req, setShowModal));
    } else {
      dispatch(editJobpositionRelated(req, editItem.id, index, setShowModal));
    }
  };

  const seeAll = () => {
    setPuesto("");
    setPosicion("");
    setEmpresa("");
    setDivision("");
    setDivisionPersonal("");
    setCentroCosto("");
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getJobpositionRelated(oOffset, limit, "", "", "", "", "", "");
  };

  const onSearchForm = async (req) => {
    setPuesto(req.puesto);
    setPosicion(req.posicion);
    setEmpresa(req.empresa);
    setDivision(req.division);
    setDivisionPersonal(req.division_personal);
    setCentroCosto(req.centro_costo);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getJobpositionRelated(
      oOffset,
      limit,
      req.puesto,
      req.posicion,
      req.empresa,
      req.division,
      req.division_personal,
      req.centro_costo
    );
    setShowModal(false);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteJobpositionRelated(id, index));
      window.alert("Se borro este registro");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">
              Posición por relación
            </h6>
            {/* <Form onSubmit={onSearch}> */}
            <Row className="justify-content-sm-end align-items-center flex-nowrap">
              {/* <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col> */}
              <Col xs="auto">
                <ButtonGroup>
                  <OverlayTrigger
                    placement="auto"
                    overlay={<Tooltip {...props}>Mostrar todos</Tooltip>}
                  >
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="auto"
                    overlay={<Tooltip {...props}>Búsqueda avanzada</Tooltip>}
                  >
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => onOpenSearch()}
                    >
                      <i className="material-icons">search</i>
                    </Button>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="auto"
                    overlay={<Tooltip {...props}>Crear registro</Tooltip>}
                  >
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </OverlayTrigger>
                  {/* <Dropdown className="mx-1">
                    <Dropdown.Toggle
                      variant="light"
                      className="btn-sm font rounded-pill"
                    >
                      <i className="material-icons">filter_list</i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {filters.map((item) => (
                        <Dropdown.Item
                          onClick={() => setTipoBusqueda(item)}
                          key={item.id}
                        >
                          {item.desc}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown> */}
                </ButtonGroup>
              </Col>
            </Row>
            {/* </Form> */}
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            jobpositionRelated &&
            jobpositionRelated.count > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable
                      columns={columns}
                      data={jobpositionRelated.data}
                    />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={jobpositionRelated.count}
                  pages={pages}
                  pagFunc={_getJobpositionRelated}
                />
              </>
            )
          )}
          {!loading &&
            jobpositionRelated &&
            jobpositionRelated.count === 0 &&
            jobpositionRelatedError === "" && (
              <Alert variant="info" className="my-4">
                Aún no hay registros, comience agregando algunos
              </Alert>
            )}
          {!!jobpositionRelatedError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {jobpositionRelatedError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={openSearch ? schemaSearch : schema}
          onSubmit={openSearch ? onSearchForm : onSubmit}
          initialValues={{
            puesto: openSearch
              ? ""
              : edit && editItem.puesto
              ? editItem.puesto
              : "",
            posicion: openSearch
              ? ""
              : edit && editItem.posicion
              ? editItem.posicion
              : "",
            empresa: openSearch
              ? ""
              : edit && editItem.empresa
              ? editItem.empresa
              : "",
            division: openSearch
              ? ""
              : edit && editItem.division
              ? editItem.division
              : "",
            division_personal: openSearch
              ? ""
              : edit
              ? editItem.division_personal
              : "",
            centro_costo: openSearch
              ? ""
              : edit && editItem.centro_costo
              ? editItem.centro_costo
              : "",
          }}
        >
          {({
            handleSubmit,
            // handleChange,
            setFieldValue,
            handleBlur,
            // values,
            touched,
            // isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {openSearch
                    ? "Búsqueda avanzada"
                    : edit
                    ? "Editar relación del puesto"
                    : "Crear relación del puesto"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!jobpositionRelatedError && openSearch && (
                  <Alert variant="danger" className="my-1 mx-3">
                    {jobpositionRelatedError}
                  </Alert>
                )}
                {!!formError && !openSearch && (
                  <Alert variant="danger" className="mt-4 mb-1 mx-3">
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column>Puesto</Form.Label>
                  <Col className="px-1">
                    <Row className="d-flex flex-wrap align-items-center">
                      <Col sm={loadingJobPosition ? 11 : 12}>
                        <Typeahead
                          id="puesto"
                          name="puesto"
                          isInvalid={touched.puesto && errors.puesto}
                          isValid={touched.puesto && !errors.puesto}
                          onBlur={handleBlur("puesto")}
                          placeholder="Puesto"
                          options={returnData(jobPositions, 2)}
                          onChange={(selected) => {
                            setFieldValue(
                              "puesto",
                              selected.length > 0 ? selected[0].id : ""
                            );
                            setJobPositionSelected(selected);
                          }}
                          selected={jobPositionSelected}
                          disabled={
                            loadingJobPosition || jobPositionsLength === 0
                          }
                        ></Typeahead>
                      </Col>
                      {loadingJobPosition ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                  {touched.puesto && errors.puesto && (
                    <div className="mx-3">
                      <small className="text-danger">{errors.puesto}</small>
                    </div>
                  )}
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column>Posicion</Form.Label>
                  <Col className="px-1">
                    <Row className="d-flex flex-wrap align-items-center">
                      <Col sm={taskLoader ? 11 : 12}>
                        <Typeahead
                          id="posicion"
                          name="posicion"
                          isInvalid={touched.posicion && errors.posicion}
                          isValid={touched.posicion && !errors.posicion}
                          onBlur={handleBlur("posicion")}
                          placeholder="posicion"
                          options={returnData(tasks, 2)}
                          onChange={(selected) => {
                            setFieldValue(
                              "posicion",
                              selected.length > 0 ? selected[0].id : ""
                            );
                            setPositionSelected(selected);
                          }}
                          selected={positionSelected}
                          disabled={taskLoader || tasksLength === 0}
                        ></Typeahead>
                      </Col>
                      {taskLoader ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                  {touched.posicion && errors.posicion && (
                    <div className="mx-3">
                      <small className="text-danger">{errors.posicion}</small>
                    </div>
                  )}
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column>Empresa</Form.Label>
                  <Col className="px-1">
                    <Row className="d-flex flex-wrap align-items-center">
                      <Col sm={loadingOrgs ? 11 : 12}>
                        <Typeahead
                          id="empresa"
                          name="empresa"
                          isInvalid={touched.empresa && errors.empresa}
                          isValid={touched.empresa && !errors.empresa}
                          onBlur={handleBlur("empresa")}
                          placeholder="Empresa"
                          options={returnData(orgs, 1)}
                          onChange={(selected) => {
                            setFieldValue(
                              "empresa",
                              selected.length > 0 ? selected[0].id : ""
                            );
                            setEmpSelected(selected);
                          }}
                          selected={empSelected}
                          disabled={loadingOrgs || orgs.length === 0}
                        ></Typeahead>
                      </Col>
                      {loadingOrgs ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                  {touched.empresa && errors.empresa && (
                    <div className="mx-3">
                      <small className="text-danger">{errors.empresa}</small>
                    </div>
                  )}
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column>Division</Form.Label>
                  <Col className="px-1">
                    <Row className="d-flex flex-wrap align-items-center">
                      <Col sm={loadingDivision ? 11 : 12}>
                        <Typeahead
                          id="division"
                          name="division"
                          isInvalid={touched.division && errors.division}
                          isValid={touched.division && !errors.division}
                          onBlur={handleBlur("division")}
                          placeholder="Division"
                          options={returnData(division, 3)}
                          onChange={(selected) => {
                            setFieldValue(
                              "division",
                              selected.length > 0 ? selected[0].id : ""
                            );
                            setDivSelected(selected);
                          }}
                          selected={divSelected}
                          disabled={loadingDivision || divisionLength === 0}
                        ></Typeahead>
                      </Col>
                      {loadingDivision ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                  {touched.division && errors.division && (
                    <div className="mx-3">
                      <small className="text-danger">{errors.division}</small>
                    </div>
                  )}
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column>Division personal</Form.Label>
                  <Col className="px-1">
                    <Row className="d-flex flex-wrap align-items-center">
                      <Col sm={loadingDivisionPersonal ? 11 : 12}>
                        <Typeahead
                          id="division_personal"
                          name="division_personal"
                          isInvalid={
                            touched.division_personal &&
                            errors.division_personal
                          }
                          isValid={
                            touched.division_personal &&
                            !errors.division_personal
                          }
                          onBlur={handleBlur("division_personal")}
                          placeholder="Division personal"
                          options={returnData(divisionPersonal, 3)}
                          onChange={(selected) => {
                            setFieldValue(
                              "division_personal",
                              selected.length > 0 ? selected[0].id : ""
                            );
                            setDivPersonalSelected(selected);
                          }}
                          selected={divPersonalSelected}
                          disabled={
                            loadingDivisionPersonal ||
                            divisionPersonalLength === 0
                          }
                        ></Typeahead>
                      </Col>
                      {loadingDivisionPersonal ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                  {touched.division_personal && errors.division_personal && (
                    <div className="mx-3">
                      <small className="text-danger">
                        {errors.division_personal}
                      </small>
                    </div>
                  )}
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column>Centro de costo</Form.Label>
                  <Col className="px-1">
                    <Row className="d-flex flex-wrap align-items-center">
                      <Col sm={loadingCenterCost ? 11 : 12}>
                        <Typeahead
                          id="centro_costo"
                          name="centro_costo"
                          isInvalid={
                            touched.centro_costo && errors.centro_costo
                          }
                          isValid={touched.centro_costo && !errors.centro_costo}
                          onBlur={handleBlur("centro_costo")}
                          placeholder="Centro de costo"
                          options={returnData(centerCost, 2)}
                          onChange={(selected) => {
                            setFieldValue(
                              "centro_costo",
                              selected.length > 0 ? selected[0].id : ""
                            );
                            setCenterCostlSelected(selected);
                          }}
                          selected={centerCostlSelected}
                          disabled={loadingCenterCost || centerCostLength === 0}
                        ></Typeahead>
                      </Col>
                      {loadingCenterCost ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                  {touched.centro_costo && errors.centro_costo && (
                    <div className="mx-3">
                      <small className="text-danger">
                        {errors.centro_costo}
                      </small>
                    </div>
                  )}
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={openSearch ? loading : saveLoading}
                  variant="primary"
                  type="submit"
                >
                  {openSearch ? (
                    <>
                      {loading && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      Buscar
                    </>
                  ) : (
                    <>
                      {saveLoading && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      Guardar
                    </>
                  )}
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default EvaluationType;
